<div class="dialog-content apply-for-support-modal" (offClick)="close()">
    <div class="box padded">
        <h2 class="script"><span>{{contentBlocks?.PopupHeader?.content}}</span></h2>

        <div [innerHtml]="contentBlocks?.PopupHeader2?.content"></div>
        <br />
        <p [innerHtml]="contentBlocks?.PopupContent?.content"></p>

        <div class="form-footer">
            <a (click)="close()" class="also-close button">{{contentBlocks?.PopupClose?.content}}</a>
        </div>
    </div>
</div>